<div class="root_container">
    <div class="main_header"><breadcrumb-header></breadcrumb-header></div>
    <div *ngIf="validQuote">
        <div *ngIf="isLoading && !hasPlans()" style="margin-left: 40%">
            <mat-spinner [diameter]="60"></mat-spinner>
        </div>    
        <div *ngIf="showHasNoPlans()">
            <br/>
            <p class="font-styling">Your quote does not contain any plans.  Please go back to quoting and review your quote. </p>
        </div>
        <div class="main_content" *ngIf="hasPlans()">
            <mat-vertical-stepper #stepper
                                  (selectionChange)="saveAndContinue($event)">
                <!-- Icon Override for edit state -->
                <ng-template matStepperIcon="edit">
                    <mat-icon *ngIf="selectedLoc === 'Medical'"
                              svgIcon="medical_case"></mat-icon>
                    <mat-icon *ngIf="selectedLoc === 'Dental'"
                              svgIcon="dental_tooth"></mat-icon>
                    <mat-icon *ngIf="selectedLoc === 'Vision'"
                              svgIcon="vision_icon"></mat-icon>
                    <mat-icon *ngIf="selectedLoc === 'Life'"
                              svgIcon="life_person"></mat-icon>
                    <mat-icon *ngIf="selectedLoc === 'Disability'"
                              svgIcon="disability_icon"></mat-icon>
                    <mat-icon *ngIf="selectedLoc === 'Voluntary'"
                              svgIcon="voluntary_icon"></mat-icon>
                    <mat-icon *ngIf="selectedLoc === 'PetBenefits'"
                              svgIcon="pets_icon"></mat-icon>
                    <mat-icon *ngIf="selectedLoc === 'LegalServices'"
                              svgIcon="legal_icon"></mat-icon>
                    <mat-icon *ngIf="selectedLoc === 'IdentityProtection'"
                              svgIcon="cyber_icon"></mat-icon>
                </ng-template>

                <!-- General Icon Overrides -->
                <ng-template matStepperIcon="Medical_incomplete">
                    <mat-icon incomplete svgIcon="medical_case"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Medical_complete">
                    <mat-icon complete svgIcon="medical_case"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Dental_incomplete">
                    <mat-icon svgIcon="dental_tooth"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Dental_complete">
                    <mat-icon svgIcon="dental_tooth"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Vision_incomplete">
                    <mat-icon svgIcon="vision_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Vision_complete">
                    <mat-icon svgIcon="vision_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Life_incomplete">
                    <mat-icon svgIcon="life_person"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Life_complete">
                    <mat-icon svgIcon="life_person"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Disability_incomplete">
                    <mat-icon svgIcon="disability_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Disability_complete">
                    <mat-icon svgIcon="disability_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Voluntary_incomplete">
                    <mat-icon svgIcon="voluntary_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Voluntary_complete">
                    <mat-icon svgIcon="voluntary_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="PetBenefits_incomplete">
                    <mat-icon svgIcon="pets_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="PetBenefits_complete">
                    <mat-icon svgIcon="pets_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="LegalServices_incomplete">
                    <mat-icon svgIcon="legal_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="LegalServices_complete">
                    <mat-icon svgIcon="legal_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="IdentityProtection_incomplete">
                    <mat-icon svgIcon="cyber_icon"></mat-icon>
                </ng-template>
                <ng-template matStepperIcon="IdentityProtection_complete">
                    <mat-icon svgIcon="cyber_icon"></mat-icon>
                </ng-template>

                <!-- Steps for the material -->
                <ng-container *ngFor="let loc of objectKeys(selectedPlansbyLoC)">
                    <mat-step *ngIf="planSummariesbyLoC[loc]" [label]="loc" [state]="sectionState(loc)" [completed]="false">
                        <ng-template matStepLabel>
                            <div *ngIf="loc==='Voluntary' || loc ==='IdentityProtection' || loc==='LegalServices' || loc==='PetBenefits' ; else nonVoluntary">
                                <div *ngIf="loc==='Voluntary'">
                                    <span>Critical Illness, Accident, Hospital Indemnity Plans</span>
                                </div>
                                <div *ngIf="loc ==='IdentityProtection'">
                                    <span>Identity Protection Plans</span>
                                </div>
                                <div *ngIf="loc==='LegalServices'">
                                    <span>Legal Services Plans</span>
                                </div>
                                <div *ngIf="loc==='PetBenefits'">
                                    <span>Pet Benefits Plans</span>
                                </div>
                            </div>
                            <ng-template #nonVoluntary>
                                <span>{{ loc }} Plans</span>
                            </ng-template>
                            <app-plan-list [plans]="selectedPlansbyLoC[loc]"></app-plan-list>
                        </ng-template>

                        <div *ngIf="isLoading">
                            <mat-spinner [diameter]="60"></mat-spinner>
                        </div>

                        <div *ngIf="!isLoading">
                            <app-plan-grid *ngIf="loCConfigs[loc].stepperView === 'grid'"
                                           [planSummaries]="planSummariesbyLoC[loc]"
                                           (selected)="testSelection($event, loc)"></app-plan-grid>

                            <app-plan-card-group *ngIf="loCConfigs[loc].stepperView === 'card'"
                                                 [planSummaries]="planSummariesbyLoC[loc]"
                                                 (selected)="testSelection($event, loc)"></app-plan-card-group>
                            <div class="button-padding" align="end">
                                <button *ngIf="stepper.selectedIndex !== 0"
                                        mat-button
                                        matStepperPrevious>
                                    BACK
                                </button>&nbsp;&nbsp;
                                <button mat-button
                                        matStepperNext
                                        class="button-color">
                                    SAVE AND CONTINUE
                                </button>
                            </div>
                        </div>
                    </mat-step>
                </ng-container>
                <!-- Below is a dummy step that is hidden in css. We are doing this in order to collapse the last step of the stepper -->
                <mat-step></mat-step>
            </mat-vertical-stepper>
        </div>
    </div>
    <br/>
    <div class="invalidText" *ngIf="!validQuote && showText">Quote not found / Invalid Quote</div>
    <div class="enrollmentButton">
        <app-enrollment-button [selectedPlans]='selectedPlansbyLoC' [allPlansByLoc]='planSummariesbyLoC'></app-enrollment-button>
    </div>
</div>
